export const API_KEY_ALL = 'all'

export const API_KEY_DWELLERS = 'dwellers'

export const API_KEY_LANDLORDS = 'landlords'

export const API_KEY_ONLINE = 'online'

export const API_KEY_INVITED = 'invited'

export const API_KEY_BLOCKED = 'blocked'

export const API_KEY_IMPORTED = 'imported'

export const API_KEY_INVALID = 'invalid'

export const API_KEY_PHONE = 'phone'

export const API_KEY_EMAIL = 'email'

export const API_KEY_PHONE_AND_EMAIL = 'phone_and_email'

export const API_KEY_EMPTY = 'empty_contact'

export const SUMMARY_STATISTIC_ITEMS = [
  API_KEY_ALL,
  API_KEY_DWELLERS,
  API_KEY_LANDLORDS,
  API_KEY_ONLINE,
  API_KEY_INVITED,
  API_KEY_BLOCKED,
  API_KEY_IMPORTED,
  API_KEY_INVALID,
  API_KEY_PHONE,
  API_KEY_EMAIL,
  API_KEY_PHONE_AND_EMAIL,
  API_KEY_EMPTY,
]

export const ROLE_STATISTIC_ITEMS = [API_KEY_DWELLERS, API_KEY_LANDLORDS]

export const STATUS_STATISTIC_ITEMS = [
  API_KEY_ONLINE,
  API_KEY_INVITED,
  API_KEY_BLOCKED,
  API_KEY_IMPORTED,
  API_KEY_INVALID,
]

export const CONTACT_STATISTIC_ITEMS = [
  API_KEY_PHONE,
  API_KEY_EMAIL,
  API_KEY_PHONE_AND_EMAIL,
  API_KEY_EMPTY,
]

export const ITEM_TRANSLATION_KEY_NAME = {
  [API_KEY_ALL]: 'Inhabitant.StatisticAllTitleKey',
  [API_KEY_BLOCKED]: 'Inhabitant.StatisticBlockedTitleKey',
  [API_KEY_DWELLERS]: 'Inhabitant.StatisticDwellersTitleKey',
  [API_KEY_EMAIL]: 'Inhabitant.StatisticEmailTitleKey',
  [API_KEY_EMPTY]: 'Inhabitant.StatisticNoneTitleKey',
  [API_KEY_IMPORTED]: 'Inhabitant.StatisticImportedTitleKey',
  [API_KEY_INVALID]: 'Inhabitant.StatisticInvalidTitleKey',
  [API_KEY_INVITED]: 'Inhabitant.StatisticInvitedTitleKey',
  [API_KEY_LANDLORDS]: 'Inhabitant.StatisticLandlordsTitleKey',
  [API_KEY_ONLINE]: 'Inhabitant.StatisticOnlineTitleKey',
  [API_KEY_PHONE]: 'Inhabitant.StatisticPhoneTitleKey',
  [API_KEY_PHONE_AND_EMAIL]: 'Inhabitant.StatisticPhoneEmailTitleKey',
}
